export default {

    /**
     * 系统服务异常
     */
    '101001': {'statusCode':101001,'statusMessage':'系统服务异常'},

    /**
     * 没有在interface中加入class文件
     */
    '101002': {'statusCode':101002,'statusMessage':' 尚未在dubbo.js中声明,无法使用'},

    /**
     * zookeeper 注册中心无法找到匹配的java服务
     */
    '101003': {'statusCode':101003,'statusMessage':'没有找到服务,也许java服务没有启动'},

    /**
     * java服务出现未知异常
     */
    '101004': {'statusCode':101004,'statusMessage':'java服务出现未知异常'},

    /**
     * 因为地址连接失败,重新选择访问地址时报错
     */
    '101005': {'statusCode':101005,'statusMessage':'zookeeper中查找访问地址错误! '},

    /**
     * 请求参数与class中定义的不符
     */
    '101006': {'statusCode':101006,'statusMessage':'请求参数不符'},

    /**
     * 用户名或者密码错误
     */
    '202006': {'statusCode':202006,'statusMessage':'用户名或者密码错误'},

    /**
     * 账户已被冻结
     */
    '202007': {'statusCode':202007,'statusMessage':'账户已被冻结'},

    /**
     * 您所在的公司(店铺)没有得到授权
     */
    '202008': {'statusCode':202008,'statusMessage':'您所在的公司(店铺)没有得到授权'},

    /**
     * 您所在的公司(店铺)的授权已经到期
     */
    '202009': {'statusCode':202009,'statusMessage':'您所在的公司(店铺)的授权已经到期'},

    /**
     * 您所在的公司审核尚未通过
     */
    '202010': {'statusCode':202010,'statusMessage':'您所在的公司审核尚未通过'},

    /**
     * 您所在的公司被冻结
     */
    '202011': {'statusCode':202011,'statusMessage':'您所在的公司被冻结'},

    /**
     * 您所在的公司已经注销
     */
    '202012': {'statusCode':202012,'statusMessage':'您所在的公司已经注销'},

    /**
     * 您所在的美容院审核尚未通过
     */
    '202013': {'statusCode':202013,'statusMessage':'您所在的美容院审核尚未通过'},

    /**
     * 您所在的美容院被冻结
     */
    '202014': {'statusCode':202014,'statusMessage':'您所在的美容院被冻结'},

    /**
     * 您所在的美容院已经注销
     */
    '202015': {'statusCode':202015,'statusMessage':'您所在的美容院已经注销'},

    /**
     * 您的身份尚未验证
     */
    '202016': {'statusCode':202016,'statusMessage':'您的身份尚未验证'},

    /**
     * 该用户被别的公司绑定
     */
    '203001': {'statusCode':203001,'statusMessage':'该用户被别的公司绑定'},

    /**
     * 绑定用户不存在需要注册
     */
    '203002': {'statusCode':203002,'statusMessage':'绑定用户不存在需要注册'},

    /**
     * 用户名已存在
     */
    '203003': {'statusCode':203003,'statusMessage':'用户名已存在'},

    /**
     * 用户编号为空
     */
    '204001': {'statusCode':204001,'statusMessage':'用户编号为空'},

    /**
     * 旧密码不正确
     */
    '204002': {'statusCode':204002,'statusMessage':'旧密码不正确'},

    /**
     * 系统不存在
     */
    '202017': {'statusCode':202017,'statusMessage':'系统不存在'},

    /**
     * 系统已经停用
     */
    '202018': {'statusCode':202018,'statusMessage':'系统已经停用'},

    /**
     * 您没有访问系统的任何权限
     */
    '202020': {'statusCode':202020,'statusMessage':'您没有访问系统的任何权限'},

    /**
     * 用户未登入
     */
    '202021': {'statusCode':202021,'statusMessage':'用户未登入'},

    /**
     * 登录信息不完整
     */
    '202022': {'statusCode':202022,'statusMessage':'登录信息不完整'},

    /**
     * 您无权访问此功能
     */
    '202023': {'statusCode':202023,'statusMessage':'您无权访问此功能'},

    /**
     * 请登录后再操作
     */
    '202024': {'statusCode':202024,'statusMessage':'请登录后再操作'},

    /**
     * 您输入的手机号为空
     */
    '203005': {'statusCode':203005,'statusMessage':'您输入的手机号为空'},

    /**
     * 您填写的手机号码与接收验证码手机号不符!
     */
    '200001': {'statusCode':200001,'statusMessage':'您填写的手机号码与接收验证码手机号不符!'},

    /**
     * 手机号码验证错误！
     */
    '200002': {'statusCode':200002,'statusMessage':'手机号码验证错误！'},

    /**
     * 支付错误
     */
    '205001': {'statusCode':205001,'statusMessage':'支付错误'},

    /**
     * 证书不匹配
     */
    '200003': {'statusCode':200003,'statusMessage':'证书验证错误'},

    /**
     * 获取数据字典错误
     */
    '200004': {'statusCode':200004,'statusMessage':'获取数据字典错误'},

    /**
     * 试用活动重复申请
     */
    '206001': {'statusCode':206001,'statusMessage':'试用活动重复申请'},

    /**
     * 订单已经支付
     */
    '205002': {'statusCode':205002,'statusMessage':'订单已经支付'},

    /**
     * 验证码错误
     */
    '200006': {'statusCode':200006,'statusMessage':'验证码错误'},

    /**
     * 申请人已经属于别的美容院
     */
    '203006': {'statusCode':203006,'statusMessage':'申请人已经属于别的美容院'},

    /**
     * 申请人已经属于代理
     */
    '203007': {'statusCode':203007,'statusMessage':'申请人已经属于代理'},

    /**
     * 手机号正在审核中
     */
    '203008': {'statusCode':203008,'statusMessage':'手机号正在审核中'},

    /**
     * 申请人已经属于平台管理员
     */
    '203009': {'statusCode':203009,'statusMessage':'申请人已经属于平台管理员'},

    /**
     * 申请人已经属于品牌商
     */
    '203010': {'statusCode':203010,'statusMessage':'申请人已经属于品牌商'},

    /**
     * 该手机号用户已经失效
     */
    '203011': {'statusCode':203011,'statusMessage':'该手机号用户已经失效'},

    /**
     * 手机号已经注册
     */
    '203004': {'statusCode':203004,'statusMessage':'手机号已经注册'},

    /**
     * 用户不存在或无权限访问系统
     */
    '202025': {'statusCode':202025,'statusMessage':'用户不存在或无权限访问系统'},

    /**
     * 操作过于频繁，后台时间限制为1分钟可以获取一次
     */
    '200007': {'statusCode':200007,'statusMessage':'操作过于频繁，请稍后再试'},

    /**
     * 停止铺货商品，没有库存不能上架
     */
    '207001': {'statusCode':207001,'statusMessage':'停止铺货商品，没有库存不能上架'},

    /**
     * 此订单状态已发生变化，请重新操作！
     */
    '208001': {'statusCode':208001,'statusMessage':'此订单状态已发生变化，请重新操作！'},

    /**
     * 订单已经发货，请勿重复发货
     */
    '208002': {'statusCode':208002,'statusMessage':'订单已经发货，请勿重复发货'},

    /**
     * 保证金可用额度不足,请充值
     */
    '205003': {'statusCode':205003,'statusMessage':'保证金可用额度不足,请充值'},

    /**
     * 比如输入数据超字段长度、类型不对、不唯一等等，总之就是违反数据库的验证的
     */
    '200008': {'statusCode':200008,'statusMessage':'输入内容格式验证错误'},

    /**
     * 营业执照已经注册
     */
    '203012': {'statusCode':203012,'statusMessage':'营业执照已经注册'},

    /**
     * 营业执照正在审核中
     */
    '203013': {'statusCode':203013,'statusMessage':'营业执照正在审核中'},

    /**
     * 您输入的营业执照注册号为空
     */
    '203014': {'statusCode':203014,'statusMessage':'您输入的营业执照注册号为空'},

    /**
     * 请完善地址信息
     */
    '209001': {'statusCode':209001,'statusMessage':'请完善地址信息'},

    /**
     * 铺货订单明细中包含不可铺货的商品，只有商品状态为2时才可以铺货。
     */
    '209002': {'statusCode':209002,'statusMessage':'铺货订单明细中包含不可铺货的商品'},

    /**
     * 没有铺货商品
     */
    '209003': {'statusCode':209003,'statusMessage':'没有铺货商品'},

    /**
     * 未设置卡号或发票抬头，不允许商品上架,请先完善店铺信息
     */
    '207003': {'statusCode':207003,'statusMessage':'未设置卡号或发票抬头，不允许商品铺货、上架操作,请先完善店铺信息'},

    /**
     * 查询时，传入查询语句编码，java端无法找到编码对应的语句，抛出此错误
     */
    '110001': {'statusCode':110001,'statusMessage':'查询编码错误'},

    /**
     * 例如 没有select
     */
    '110002': {'statusCode':110002,'statusMessage':'查询语句格式错误'},

    /**
     * java端查询发生异常
     */
    '110003': {'statusCode':110003,'statusMessage':'查询发生异常'},

    /**
     * 查询语句必须的语句编码错误,也有可能是 语句编码还没准备好
     */
    '110004': {'statusCode':110004,'statusMessage':'对应的查询编码不存在'},

    /**
     * 无验证码或者已过期,请重新获取!
     */
    '200005': {'statusCode':200005,'statusMessage':'无验证码或者已过期,请重新获取!'},

    /**
     * 参数传递错误,参数名必须大小写匹配
     */
    '111001': {'statusCode':111001,'statusMessage':'参数传递错误'},

    /**
     * 流程实例id错误
     */
    '211001': {'statusCode':211001,'statusMessage':'流程不存在'},

    /**
     * 必须登陆才能访问,原因是session中没有user对象
     */
    '211002': {'statusCode':211002,'statusMessage':'必须登陆才能访问'},

    /**
     * 该流程已经停用
     */
    '211004': {'statusCode':211004,'statusMessage':'该流程已经停用'},

    /**
     * 权限不足，无法发起该流程！
     */
    '211003': {'statusCode':211003,'statusMessage':'权限不足，无法发起该流程！'},

    /**
     * 流程信息已变更，请刷新页面!
     */
    '211005': {'statusCode':211005,'statusMessage':'流程信息已变更，请刷新页面!'},

    /**
     * 密码长度不可超过32位
     */
    '204003': {'statusCode':204003,'statusMessage':'密码长度不可超过32位'},

    /**
     * 该商品已下架
     */
    '207002': {'statusCode':207002,'statusMessage':'该商品已下架'},

    /**
     * 流程设置错误,例如缺少开始节点等,一般是因为手动更改数据库引起的
     */
    '211006': {'statusCode':211006,'statusMessage':'流程设置错误'},

    /**
     * 流程id错误
     */
    '211007': {'statusCode':211007,'statusMessage':'错误的流程信息'},

    /**
     * 流程异常，例如最后一步操作不存在，一般是手动更改数据库引起
     */
    '211008': {'statusCode':211008,'statusMessage':'流程异常，无法操作'},

    /**
     * 参数不足
     * showFlow需要：biz_id/instance_id/flow_code+flow_version
     * doFlow需要：flow_instance + flow_record
     *
     */
    '211009': {'statusCode':211009,'statusMessage':'参数不足,详情请查询API'},

    /**
     * 比如开始节点不能发出废弃操作等
     */
    '211010': {'statusCode':211010,'statusMessage':'不允许这么操作！'},

    /**
     * 流程组件数据保存失败,详情请看控制台
     */
    '211011': {'statusCode':211011,'statusMessage':'流程组件数据保存失败'},

    /**
     * 开始节点的操作按钮执行的后台脚本中，必须执行流程的《Flow.setBiz》方法来绑定流程和业务对象。
     */
    '211012': {'statusCode':211012,'statusMessage':'缺少业务信息'},

    /**
     * 自动节点需要根据业务来返回需要流转的节点编码，如果不指定节点编码，抛出此异常
     */
    '211013': {'statusCode':211013,'statusMessage':'自动节点没有指定流转目的地'},

    /**
     * 自动节点返回的目标节点编码不存在
     */
    '211014': {'statusCode':211014,'statusMessage':'自动节点返回的目标节点编码不存在'}
}
module.exports = exports.default;